"use client";

// packages/eden-text/src/components/Text5.jsx
import styled from "styled-components";
import shared from './shared.js';
import { jsx } from "react/jsx-runtime";
var Container5 = styled.div`
  font: var(--unity-text5-citation);
  ${shared};
`;
var Text5 = ({ children, renderAs = "div", ...props }) => /* @__PURE__ */ jsx(Container5, { as: renderAs, ...props, children });
Text5.displayName = "Text5";
var Text5_default = Text5;
export {
  Text5_default as default
};
